import type { Vero1BannerState } from "shared/interfaces/api/vero1";

/* A submitted review that is not governing right now. The banner says so in
   its own words; the leasing tab must not read as a live verdict while it
   holds. Agents get no line: the pending re-review hold is carried by the
   "Lumen screened again" strip (spec 4.1) and every hold is on record in the
   Activity tab, which leasing cannot read the VERO1 rows of. */
export const reviewHoldNote = (
  bannerState: Vero1BannerState | null | undefined,
  isAgent: boolean
): string | null => {
  if (isAgent || !bannerState) return null;
  switch (bannerState.state) {
    case "awaiting_applicants":
      return "On hold — an applicant was added after this review. Queued for VERO1 to confirm this review once every applicant has submitted.";
    case "pending_review":
    case "override_not_applied":
      return "On hold — queued for VERO1 to confirm this review.";
    default:
      return null;
  }
};
